import { Container } from "@mui/material";
import { styled } from "@mui/system";

export const CenteredContainer = styled(Container)`display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;` 